(function () {

  const teaser_card_slider_list = document.querySelectorAll('.js_category_slider')

  for (let i = 0; i < teaser_card_slider_list.length; i++) {
    const slider = teaser_card_slider_list[i]
    initTeaserCardSlider(slider)
  }

  function getSlideIndexByClass(slider, selectClass) {
    let selectedCatIndex
    const slideList = slider.querySelectorAll('.swiper-slide')

    for (var i = 0; i < slideList.length; i++) {
      const element = slideList[i]
      if (element.classList.contains(selectClass) && !element.classList.contains('swiper-slide-duplicate')) {
        selectedCatIndex = i
      }
    }

    return selectedCatIndex
  }

  function initTeaserCardSlider(slider) {

    const number_of_slides = slider.querySelectorAll('.swiper-slide').length;
  

    const slides_to_show_1440 = number_of_slides < 5 ? number_of_slides : 5;
    const slides_to_show_1200 = number_of_slides < 5 ? number_of_slides : 4;
    const slides_to_show_767 = number_of_slides < 3 ? number_of_slides : 3;
    const slides_to_show_default = number_of_slides < 3 ? number_of_slides : 2.3;
    const sliderParentSec = slider.closest('.js_category_slider_sec');


    const sliderOptions2 = {
      spaceBetween: 15,
      grabCursor: true,
      a11y: false,

      loop: true,
      // slidesPerView: slides_to_show_default,
      slidesPerView: slides_to_show_default,

      breakpoints: {
        0: { /* when window >=0px - webflow mobile landscape/portriat */
          spaceBetween: 15,
        },
        480: { /* when window >=0px - webflow mobile landscape/portriat */
          spaceBetween: 15,
        },
        767: { /* when window >= 767px - webflow tablet */
          spaceBetween: 15,
          slidesPerView: slides_to_show_767,
        },
        1200: { /* when window >= 988px - webflow desktop */
          spaceBetween: 15,
          slidesPerView: slides_to_show_1200,

        },
        1440: { /* when window >= 988px - webflow desktop */
          spaceBetween: 15,
          slidesPerView: slides_to_show_1440,

        }
      },
      navigation: {
        nextEl: sliderParentSec.querySelector('.swiper-button-next'),
        prevEl: sliderParentSec.querySelector('.swiper-button-prev'),
      },
    }

    const swiper = new Swiper(slider, sliderOptions2)
    swiper.slideTo(getSlideIndexByClass(slider, 'selected'))
  }

})()
